
export const fetchPayload = async (variant_id, variant_type) => {
    try {
        const url = _get_viewer_variants_api(variant_id, variant_type);
        const response = await fetch(url);
        if(!response.ok) { throw new Error(`Fetch Call Cannot Be Made`)}
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('fetchPayload error', error);
    }
};

const _get_viewer_variants_api = (variant_id, variant_type) => {
    switch(variant_type){
        case "bco":
            return `https://8r5iz5bkt0.execute-api.us-east-1.amazonaws.com/dev/bigcommerce/public/viewer_variants?variant_id=${variant_id}`; // BigCommerce
        case "cus":
            return `https://oomxrg1ojl.execute-api.us-east-1.amazonaws.com/dev/public/viewer/variants?variant_id=${variant_id}`; // Custom Store            
        default:
            return `https://mpyo8741mj.execute-api.us-east-1.amazonaws.com/dev/public/viewer_variants?variant_id=${variant_id}`
    }
};

export const fetchStoreSettings = async (variant_type, store_id) => {
    try {
        const url = _store_settings_api(variant_type, store_id);
        const response = await fetch(url);
        if(!response.ok) { throw new Error(`Fetch Call Cannot Be Made`)}
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('fetchPayload error', error);
        return {
            result: {
                ar_experience: null,
                cLogo: null,
                dynamic_text_settings: { custom_text_status: false },
                ga_id: null,
                klaviyo_id: null,
                yotpo_id: null,
            }
        }
    }
};

const _store_settings_api = (variant_type, store_id) => {
    switch(variant_type){
        case "cus":
            return `https://oomxrg1ojl.execute-api.us-east-1.amazonaws.com/dev/public/store?store_id=${store_id}`; // custom_store
        default:
            return `https://mpyo8741mj.execute-api.us-east-1.amazonaws.com/dev/public/store?store_id=${store_id}`; // shopify && bigcommerce
    }
};

export const fetchReviews = async (product_id, api_key) => {
    try {
        const url = `https://api-cdn.yotpo.com/v1/widget/${api_key}/products/${product_id}/reviews.json?sort=date&star=5`;
        const response = await fetch(url);
        if(!response.ok) { throw new Error(`Fetch Call Cannot Be Made`)}
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('fetchPayload error', error);
        return { reviews: false }
    }
};

export const fetchKlaviyoOptions = async (klaviyo_data) => {
    try {
        const url = 'https://a.klaviyo.com/api/track';
        const response = await fetch(url, _get_klaviyo_data(klaviyo_data));
        if(!response.ok) { throw new Error(`Fetch Call Cannot Be Made`)}
        const data = await response.json();
        console.log('klaviyo options', data);
        return data;
    } catch (error) {
        console.log('fetchKlaviyoOptions error', error);
    }
};

const _get_klaviyo_data = (data) => {
    const options = {
      method: 'POST',
      headers: {accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams({
        data: data
      })
    };

    return options;
};

// get HRX data
export const fetchHRX = async () => {
    const hrxPayload = {
        has_ua: Boolean(navigator?.userAgent),
        has_WebGPU: Boolean(navigator?.gpu),
        has_hints: Boolean(navigator?.userAgentData),
        can_screen: Boolean(window?.screen),
        max_tp: Boolean(navigator?.maxTouchPoints) ? navigator.maxTouchPoints : 0,
        ua: Boolean(navigator?.userAgent) ? navigator.userAgent : "hrx",
        low_mobile: Boolean(navigator?.userAgentData?.mobile) ? navigator.userAgentData.mobile : "hrx",
        low_brands: Boolean(navigator?.userAgentData?.brands) ? navigator.userAgentData.brands : { "hrx": "hrx" },
        low_platform: Boolean(navigator?.userAgentData?.platform) ? navigator.userAgentData.platform : "hrx",
        height: Boolean(window?.screen) ? window.screen.height : 0,
        width: Boolean(window?.screen) ? window.screen.width : 0,
        avail_height: Boolean(window?.screen) ? window.screen.availHeight : 0,
        avail_width: Boolean(window?.screen) ? window.screen.availWidth : 0,
        dpr: Boolean(window?.devicePixelRatio) ? window.devicePixelRatio : 1,
        href: window.location.href
    };

    try {
        const url = `https://74urwkijvd.execute-api.us-east-1.amazonaws.com/dev/HRXlite`
        const response = await fetch(url, {
                mode: "cors",
                method: "POST",
                body: JSON.stringify(hrxPayload),
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            },
        );

        if (!response.ok) { throw new Error(`Push Call Cannot Be Made`) };
        const data = await response.json();
        
        return data;
    } catch (error) {
        console.log('fetchPayload error', error);
        return {
            intent: "cant",
            target: "fallback",
            preferred_renderer: 0,
            version: -1,
            offline: true
        }
    };
};